 // import Swiper JS
 import Swiper, {
   Autoplay,
   Navigation
 } from 'swiper';
 // import Swiper styles
 import 'swiper/css';

 // configure Swiper to use modules
 Swiper.use([Autoplay, Navigation]);

 export function initCardCarousel() {
   if (window.acf) {
     window.acf.addAction(
       'render_block_preview/type=card-carousel',
       cardCarousel
     );
   }
 }

 export function cardCarousel() {

   if (!document.querySelector('.card-carousel'))
     return;

   var slideCount = document.querySelectorAll('.card-carousel-item').length;

   const swiper = new Swiper('.card-carousel', {
     // Optional parameters
     slidesPerView: 3,
     slidesPerGroup: 3,
     spaceBetween: 40,
     // Responsive breakpoints
     breakpoints: {
       // when window width is >= 320px
       320: {
         slidesPerView: 1,
         slidesPerGroup: 1,
         loop: slideCount > 1
       },
       // when window width is >= 640px
       768: {
         slidesPerView: 2,
         slidesPerGroup: 2,
         loop: slideCount > 2
       },
       1216: {
         slidesPerView: 3,
         slidesPerGroup: 3,
         loop: slideCount > 3
       }
     },
     navigation: {
       nextEl: '.card-carousel-next',
       prevEl: '.card-carousel-prev',
     },
     on: {
       init: function (s) {
         setH4Height(s)
       },
       resize: function (s) {
         setH4Height(s)
       }
     }
   });

   function setH4Height(s) {
     let h4Height = 0;
     [...s.slides].forEach(function (v, i, a) {
       let h4 = v.querySelector('h4');
       h4.style.minHeight = '';
       if (h4.offsetHeight > h4Height) h4Height = h4.offsetHeight;
     });
     [...s.slides].forEach(function (v, i, a) {
       let h4 = v.querySelector('h4');
       h4.style.minHeight = h4Height + 'px';
     });
   }
 }
